import React, { useState, useRef, useEffect, useCallback } from "react";
import { useDialog } from './useDialog';
import api, { sendCombinedChangeCommon } from './api';
import DataTable from 'react-data-table-component';
//import DataTableExtensions from "react-data-table-component-extensions";
//import "react-data-table-component-extensions/dist/index.css";
import { FaEdit, FaStop, FaPlay,  FaArrowRight, FaLongArrowAltRight } from "react-icons/fa";

import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

//import DatePicker, { registerLocale } from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";
import ExerciseTimerWithList from './ExerciseTimerWithList';

import './Doctors.css';
import useAuth from "../hooks/useAuth";

import EscalationModal from './EscalationModal';

import './SlidingDrawer.css';
import Sequences from './Sequences';

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: '1000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '30px',
    width: '60vw',
    height: '80vh',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    border: '1px solid #ccc'
  }
};

const PatientSequences = ({patientCard, activeTab}) => {
  const { auth } = useAuth();
  const [sequences, setSequences] = useState([]);
  const [rawSequences, setRawSequences] = useState([]);        // Used by child
  const [displaySequences, setDisplaySequences] = useState([]); // Used by DataTable

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [appointment, setAppointment] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [remainingTime, setRemainingTime] = useState(0);
  const [todayDate, setTodayDate] = useState(new Date());
  const [therapistView, setTherapistView] = useState(false);
  const [ongoingSequenceExersFinCount, setongoingSequenceExersFinCount] = useState();
  const [showModal, setShowModel] = useState(false);
  const [escalations, setEscalations] = useState([]);
  const [therapistName, setTherapistName] = useState("");
const [sessionMarked, setSessionMarked] = useState(false);
const [shouldPromptSessionOver, setShouldPromptSessionOver] = useState(false);
const location = useLocation();
const navigate = useNavigate();
const [sessionOverModalOpen, setSessionOverModalOpen] = useState(false);
const [therapistComment, setTherapistComment] = useState("");
const [showExerComment, setShowExerComment] = useState("");
const [previousComments, setPreviousComments] = useState(["Patient needs rest", "Good Session, happy patient",
  "Pain reported while some exercise", "Pain but Good Session", 
  "Sequences modified due to pain", "Good session, Patient has given feedback"]); // Replace with dynamic data if needed

const [sessionStatus, setSessionStatus] = useState('');
const [showAddModal, setShowAddModal] = useState(false);
const [updateReqd, setUpdateReqd] = useState(false);
const [selectedItem, setSelectedItem] = useState(null);
const [suffixText, setSuffixText] = useState("");
const [seqChanged, setSeqChanged] = useState(false);
const [leadTherapist, setLeadTherapist] = useState("");
const [leadTherapistDesignation, setLeadTherapistDesignation] = useState("");
const [helperTherapist1, setHelpTherapist1] = useState("");
const [helperTherapist2, setHelpTherapist2] = useState("");
const [therapists, setTherapists] = useState([]);
const [showNextApptModal, setShowNextApptModal] = useState(false);
const [nextApptDate, setNextApptDate] = useState(new Date());
const [nextApptShowPicker, setNextApptShowPicker] = useState(false);
const [scActualStartTime, setScActualStartTime] = useState('');
const [scActualEndTime, setScActualEndTime] = useState('');
const [scExerciseBulkStatus, setScExerciseBulkStatus] = useState('');
const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
const { dialogNode, showAlert, showConfirm, showPrompt } = useDialog();

  useEffect(() => {
    console.log("patientcard ", patientCard);
    if (auth.roles && auth.roles.indexOf("therapist") !== -1) {
      console.log("setting therpist view and activeTab = ", activeTab);
      setTherapistView(true);
    }
    var d = new Date();
    setTodayDate(d.toDateString());
    getPatientSequences();

    if (activeTab === 3) {
      //getPatientSequences();
      getPatientEscalations();
    }
  }, []);

useEffect(() => {

}, [activeTab]);


useEffect(() => {
  const handleRouteChange = (e) => {
    if (shouldPromptSessionOver && !sessionMarked) {
      setShowLeaveConfirm(true);
    }
  };

  window.addEventListener("popstate", handleRouteChange);
  return () => window.removeEventListener("popstate", handleRouteChange);
}, [shouldPromptSessionOver, sessionMarked]);


  const colorPalette = ['#4db8ff','#ff6b6b','#ffa94d','#6bcf63','#9b59b6','#ffcc00','#3498db','#e67e22','#1abc9c','#e84393'];
  const conditionalRowStyles = [{ when: () => true, style: (_, idx) => ({ backgroundColor: colorPalette[idx % colorPalette.length], color:'#333', fontWeight:700 }) }];
  
  const updateReq = useRef(null);
  const sseq = useRef(null);
  
  
  const getTherapists = () => {
      api.get(`${process.env.REACT_APP_URL}/users/sessionstaff/therapist`)
        .then((res) => setTherapists(res.data))
        .catch((err) => console.error('Error fetching therapists:', err));
  };
  

  const toDatetimeLocal = (d) => {
    const dt = d ? new Date(d) : new Date();
    if (isNaN(dt)) return '';
    const pad = n => String(n).padStart(2, '0');
    return `${dt.getFullYear()}-${pad(dt.getMonth()+1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
  };

  const closeNextApptModal = () => {
    setLeadTherapist(null);
    setLeadTherapistDesignation(null);
    setHelpTherapist1(null);
    setHelpTherapist2(null);
    setShowNextApptModal(false);
    navigate('/TherapistDashboard');
  };

  const scheduleNextAppointment = (newStart) => {
    // Calculate end time from planned exercise duration (stored in seconds) or 50 min default
    const totalSec = rawSequences.reduce((sum, ex) => sum + (ex.duration ?? 60) * (ex.repetition ?? 1), 0);
    const durMin = rawSequences.length > 0 ? Math.max(10, Math.ceil(totalSec / 60)) : 50;
    const endDate = new Date(new Date(newStart).getTime() + durMin * 60 * 1000);
    const newAppointment = {
      ...appointment,
      start: newStart,
      end: endDate,
      isToday: false,
      username: leadTherapist || appointment?.username,
      date: newStart,
      status: 'scheduled',
    };
    delete newAppointment._id;
    delete newAppointment.__v;
    api.post(`${process.env.REACT_APP_URL}/appointments/dynamic/add`, newAppointment)
      .then(() => {
        alert('✅ Next appointment scheduled!');
        closeNextApptModal();
      })
      .catch(err => alert('Error scheduling: ' + (err.response?.data || err.message)));
  };

  const getPatientSequences = () => {
    console.log("patient card", patientCard);
    
    api.get(`${process.env.REACT_APP_URL}/patients/consultation/${patientCard}`)
    .then(response => {
      // check if any services present or not
      console.log("Fetched patient consultation ==", response);

      if (response.data && response.data.suggestedServices )
      { 
        var ss = response.data.suggestedServices;
        if (ss.length == 0 )
        {
          showAlert("Patient has no 'therapy service suggestions'. Please assign from 'Consultation'.", 'warning');
          return;
        }
        var TherapyS = ss.filter((s) => s.org == "MedicalyogaTherapyCentre");
        if (!TherapyS || TherapyS.length == 0 )
        {
          showAlert("Patient has no 'therapy service suggestions'. Please assign from 'Consultation'.", 'warning');
          return;
        }
      }
      if (response.data && response.data.sequences )
      { 
        var ss = response.data.sequences;
        if (ss.length == 0 )
        {
          showAlert("Patient has no 'sequences'. Please assign from 'Consultation'.", 'warning');
          return;
        }
      }
      var therapist = response.data && response.data.therapist ? response.data.therapist : null;
      var setDefault = 0;
      api.get(`${process.env.REACT_APP_URL}/appointments/patient/${patientCard}/today/upcoming/1?_=${new Date().getTime()}`)
      .then(resp2 => {
        
        var seqs = response.data && response.data.sequences ? response.data.sequences : [];
        var ss = response.data && response.data.suggestedServices ? response.data.suggestedServices : [];
        if (therapist || 
          (resp2.data && resp2.data.resultsUTC && 
           resp2.data.resultsUTC.length > 0 && resp2.data.resultsUTC[0]?.username
          )) {
          var appt = resp2.data.resultsUTC[0];
          if (appt)
          {
            console.log("setting appontment = ", appt._id);
            setAppointment(appt);   
          }
          // else schedule an appt
        }
        else
        { 
          console.log("no appointment, seqs = ", seqs);
          setIsModalOpen(true);
          setAppointment(appt);           
        }
        //setSequences(seqs);  
        setRawSequences(seqs);       // for ExerciseTimerWithList
        setDisplaySequences(seqs);   // for DataTable
        updateSeqsAndStorage(seqs);
        console.log("getPatientSeqs = ", seqs);

      })
      .catch(e => console.error('Error fetching Patient Appointments', e));
    })
    .catch(error => console.error('Error fetching Patient Sequences:', error));
  };

  
  const getPatientEscalations = () => {
      api.get(`${process.env.REACT_APP_URL}/patients/profiles/${patientCard}`)
      .then(response => { 
          console.log("students mongo fetch",response.data.therapist);
          if (response.data == null)
          {
            alert ("Not found");
            return;
          }
          setTherapistName(response.data.therapist || "veena");
          setEscalations(response.data.previousEscalations || []);
        })
        .catch(error =>
            alert('Not found. Please add new Entry!'));
  };

  const updateModSequence = (row) => {
    sendToBackend(row, null, 1);
  };

  const sendToBackend = (row, idx, send = 0) => {
    if (!send && idx != null && ["Completed", "Skipped"].includes(row.status))
    {
      var val = row;
      val["idx"] = idx;
      setShowExerComment(row);
    }
    else if (!send)
    {
        setShowExerComment("");
    }

    setDisplaySequences(prev => {
      const updated = [...prev];
      updated[idx] = row;
      return updated;
    });

    if (send)
    {
      setStartTime(row.startTime);
      setEndTime(row.endTime);
      row.executedate = new Date().toDateString();
      console.log("sendTobackend ", row.name);
      api.post(`${process.env.REACT_APP_URL}/patients/consultation/patientsequences/${patientCard}/${row.name}`, row)
      .then(() => getPatientSequences())
      .catch(error => { 
        console.error('Error updating sequences:', error); 
        alert("Error updating Sequences. Please try again!"); 
      });
    }
  };

  const updateSeqsAndStorage = (data) => {

    setRawSequences(data);
    setDisplaySequences(data);
    const SNAPSHOT_KEY = `workoutSnapshot-${appointment?._id}`;
    
    var savedLotStr = sessionStorage.getItem(SNAPSHOT_KEY);
    console.log("update lot = ", appointment?._id, data);
    if (savedLotStr) {
              var savedLot = JSON.parse(savedLotStr);  // Convert string to object
              savedLot.exercises = data;            // Update property
              sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(savedLot));  // Convert back to string and save
    }
  }

  const sendExersToBackend = async (exers, row) => {
    console.log("sendExersTobackend ", exers, row);
      
      //setSequences(exers);
      setDisplaySequences(exers);
      api.post(`${process.env.REACT_APP_URL}/patients/consultation/patientsequences/${patientCard}/all`, exers)
      .then((resp) => {
        console.log("seq updated", resp);
        if (resp.data.updateReqd && resp.data.updateReqd == true)
        {            
            updateSeqsAndStorage(resp.data.data);
        }
      })
      .catch(error => { 
        console.error('Error updating sequences:', error); 
        alert("Error updating Sequences. Please try again!"); 
      });
   
  };

  const updateAppointment = (value, field) => {
    setAppointment(prev => ({
      ...prev,
      [field]: value,
      escalated: true,
      escalationDate: new Date()
    }));
  };

  function setValue(value, idx, key) {
    var newSeqs = displaySequences.slice();    
    newSeqs[idx][key] = value;
    setDisplaySequences(newSeqs);
    updateModSequence(newSeqs[idx]);
  }

  const handleSeqChange = (e, data, comp, toSend, updateReqd) => {
    console.log("data , toSend, update", data, toSend, updateReqd);

    if (!toSend) {
      sseq.current = data;
      setSeqChanged(true);
      updateReq.current = updateReqd;
      setUpdateReqd(updateReqd);
    }
  };

   const handleSave = async (e) => {
      console.log("save = ")
      setShowAddModal(false);

      var stype = "all";
      var newSeqs = displaySequences.slice();

      const addMissingStatus = (arr, defaultStatus = 'notStarted') =>
        arr.map(item => ({
          ...item,
          status: item.status ?? defaultStatus,
          patientCard: patientCard
        }));

      const final = [
        ...addMissingStatus(newSeqs),
        ...addMissingStatus(sseq.current.combinedRows),
      ];
      
      const payload = { data: { stype } };
      if (seqChanged) 
        payload.data.sequences = final;
      payload.data["updateReqd"] = true;
      console.log("payload = ", payload)
      setSequences(payload.data.sequences);
      //sendCombinedChangeCommon(e, stype, patientCard, payload);
      await sendExersToBackend(payload.data.sequences);
      getPatientSequences();
  };

  const openModalForAdd = () => {
    setShowAddModal(true);
  };


  function setTextValue(value, idx, key) {
    var newSeqs = displaySequences.slice();
    var oldVal = newSeqs[idx][key];
    if (!oldVal)
      oldVal = "";
    var d = new Date();
    var dateVal = "-";
    if (!isNaN(d.getTime())) {
          // Format is locale-dependent; using en-GB here
      dateVal = d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    }
    newSeqs[idx][key] = dateVal + " : " + value + "\n" +  oldVal;
    //setSequences(newSeqs);
    setDisplaySequences(newSeqs);
    updateModSequence(newSeqs[idx]);
  }

  const columns = [
    //{ name:'', selector:'id', cell: (_, idx) => <div style={{width:20,height:20,borderRadius:'50%',backgroundColor:colorPalette[idx],marginRight:8,fontWeight:400}}/>, ignoreRowClick:true, allowOverflow:true, button:true },
  
    { name: '',
  selector: row => row && row.status,
  sortable: true,
  width: '140px',
  wrap: true,
  cell: row => {
    const status = row?.status;

    const statusIcons = {
      notStarted: { icon: '📅', label: row.duration },
      OnGoing:    { icon: '⏱️', label: remainingTime },
      Completed:  { icon: '✅', label: '' },
      Skipped:    { icon: '⏭️', label: 'Skipped' }
    };

    const { icon, label } = statusIcons[status] || { icon: '❓', label: 'Unknown' };

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span>{icon}</span>
        <span>{label}</span>
      </div>
    );
  }
},
    { name:'Name', sortable:true, selector: row => row && row.name, width:'110px', wrap:true, cell: (row, idx) => <span style={{color: colorPalette[idx], fontWeight:700}}>{row.name}</span> },
    //{ name:'Status', selector: row=> row && row.status, sortable:true, width:'110px', wrap:true },
   
    { name:'Pending Repetitions', selector: row=> row && row.pendingreps, sortable:true, width:'110px', wrap:true },
    { name:'Repetition', selector: row=> row && (row.repetition ?? 1), sortable:true, width:'110px', wrap:true,
      cell: (row, idx) => 
      <textarea rows="1" cols="2" value={row?.repetition || ''} 
        disabled={row.status === 'Completed' || row.status == 'OnGoing'} 
        onClick={async () => {
          const newVal = await showPrompt('Enter Repetition:', String(row?.repetition ?? ''));
          if (newVal !== null) {
            setValue(newVal, idx, 'repetition');
          }
        }}
      />
     },
    { name:'Duration', selector: row=> row && (row.duration ?? 1), sortable:true, width:'110px', wrap:true,
       cell: (row, idx) =>
      <textarea rows="1" cols="2" value={row?.duration || ''}
        disabled={row.status === 'Completed' || row.status == 'OnGoing'}
        onClick={async () => {
          const newVal = await showPrompt('Enter Duration (sec):', String(row?.duration ?? ''));
          if (newVal !== null) {
            setValue(newVal, idx, 'duration');
          }
        }}
      />
     },

    //{ name:'Last Executed', selector: row=> row && row.executedate, sortable:true, width:'110px', wrap:true },
    { name:'Consultation Remarks', selector: row=> row && row.remarks, wrap:true, 
      cell: (row, idx) => 
      <textarea rows="4" cols="50" value={row?.remarks || ''} 
        disabled={therapistView === true} 
        onClick={async () => {
          const newVal = await showPrompt('Enter Remarks:', row?.remarks || '');
          if (newVal !== null) {
            setTextValue(newVal, idx, 'remarks');
          }
        }}
      />
      },
    { name:'Comments', selector: row=> row && row.comments, wrap:true, 
      cell: (row, idx) => 
      <textarea rows="4" cols="50" value={row?.comments || ''}  
        onClick={async () => {
          const newVal = await showPrompt('Enter Comments:', row?.comments || '');
          if (newVal !== null) {
            setTextValue(newVal, idx, 'comments');
          }
        }}
       /> 
      }
  ];

  const openSessionCommentsEscalate = () => {
    getPatientEscalations();
    setShowModel(true);
  }
  
  const checkAndUpdateRemaining =(status, reorderedExers) => {
   console.log("checkAndUpdateRemaining ", status, reorderedExers);
    api.post(
      `${process.env.REACT_APP_URL}/patients/consultation/patientsequences/updateremaining/${patientCard}/${status}`,
      {"reorderedExers": reorderedExers}
    )
    .then((resp) => {
      //if (status != 'notStarted' && status != "restarted") // Skipped / Completed
      //  alert("Updated ✅. Please mark it over with comments");
      ////getPatientSequences();
      updateSeqsAndStorage(resp.data.data);
    })
    .catch((e) => {
      console.error("Error updating sequences:", e);
      showAlert(e.message || "Error marking session. Please try again!", 'error');
    });
  }

const handleMarkSessionWithComment = async (commentStatus) => {

  if (commentStatus.toLowerCase() == "skipped")
  {
    if (!(await showConfirm("Are you sure to skip this session ?"))) return;
  }
  if (!leadTherapist || leadTherapist == "selectT")
  {
    showAlert("Please update the therapist who Led the session", 'warning');
    return;
  }

  // Bulk-mark remaining exercises if therapist chose to
  if (scExerciseBulkStatus && rawSequences.length > 0) {
    const updatedExers = rawSequences.map(seq => {
      if (['notStarted', 'Pending', 'OnGoing'].includes(seq.status)) {
        return { ...seq, status: scExerciseBulkStatus, pendingreps: 0 };
      }
      return seq;
    });
    try {
      await api.post(
        `${process.env.REACT_APP_URL}/patients/consultation/patientsequences/updateremaining/${patientCard}/${scExerciseBulkStatus}`,
        { reorderedExers: updatedExers }
      );
    } catch (e) {
      console.error('Error bulk-updating exercises:', e);
    }
  }

  const isScheduled = appointment?.status?.toLowerCase() === 'scheduled';
  const payload = {
    timeSpent: endTime && startTime ? (endTime - startTime) / (1000 * 60) : 0,
    sessionComment: therapistComment.trim(),
    status: commentStatus,
    startTime: appointment.startTime,
    leadTherapist: leadTherapist,
    helperTherapist1: helperTherapist1,
    helperTherapist2: helperTherapist2,
    leadTherapistDesignation: leadTherapistDesignation,
    ...(scActualEndTime && { actualEndTime: scActualEndTime }),
    ...(isScheduled && scActualStartTime && { actualStartTime: scActualStartTime }),
  };

  api.post(
      `${process.env.REACT_APP_URL}/patients/consultation/patientsequences/sessiondone/${patientCard}/${appointment._id}`,
      payload
    )
    .then(() => {
      const SNAPSHOT_KEY = `workoutSnapshot-${appointment?._id}`;
      sessionStorage.removeItem(SNAPSHOT_KEY);
      setSessionMarked(true);
      setTherapistComment("");
      setSessionOverModalOpen(false);
      setNextApptDate(new Date());
      setNextApptShowPicker(false);
      setShowNextApptModal(true);
    })
    .catch((e) => {
      console.error("Error updating sequences:", e);
      showAlert(e.message || "Error marking session. Please try again!", 'error');
    });
};

  const patientDoneForTheDay = () => {
    var duration = (endTime - startTime)/(1000*60);
    api.post(`${process.env.REACT_APP_URL}/patients/consultation/patientsequences/sessiondone/${patientCard}/`, { timeSpent: duration })
    .then(() => {
      alert("Session Over");
      setSessionMarked(true); // ✅ IMPORTANT
    })
    .catch(e => { console.error('Error updating sequences:', e); alert("Error updating Sequences. Please try again!"); });
  };

  const handleClose = () => {
    if (isModalOpen) {
      setIsModalOpen(false);
      getPatientSequences();
    }
  };

  
  return (
    <div>
      {dialogNode}
      {showLeaveConfirm && (
        <div style={{
          position:'fixed',inset:0,background:'rgba(0,0,0,0.45)',
          display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999
        }}>
          <div style={{background:'#fff',borderRadius:10,padding:'24px 28px',maxWidth:400,width:'90vw',boxShadow:'0 8px 32px rgba(0,0,0,0.18)'}}>
            <p style={{fontSize:15,color:'#222',marginBottom:20}}>
              Workout is complete, but you haven't marked the session over. Do you really want to leave?
            </p>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <button style={{padding:'8px 20px',borderRadius:6,border:'none',background:'#eee',color:'#333',fontWeight:600,cursor:'pointer'}}
                onClick={() => { setShowLeaveConfirm(false); navigate(location.pathname); }}>
                Stay
              </button>
              <button style={{padding:'8px 20px',borderRadius:6,border:'none',background:'#e53935',color:'#fff',fontWeight:600,cursor:'pointer'}}
                onClick={() => setShowLeaveConfirm(false)}>
                Leave
              </button>
            </div>
          </div>
        </div>
      )}
      {isModalOpen ?
       (
        <div>
          {rawSequences.length > 0 ?
          <div>
            <ExerciseTimerWithList 
              exercises={rawSequences} 
              showButtons={appointment} 
              patientCard={patientCard}
              therapistName={therapistName}
              onRemainingTimeChange={(rt) => setRemainingTime(rt)}
              onWorkoutStart={(status, reorderedExers) => {
                checkAndUpdateRemaining(status, reorderedExers);
              }} 
              onParsedData={(row, idx) => sendToBackend(row, idx, 0)}
              onExerChange={exers => sendExersToBackend(exers)}
              onWorkoutComplete={(status, reorderedExers) => {
                checkAndUpdateRemaining(status, reorderedExers);
                setSessionStatus(status); 
                if (status == "restarted")
                  setShouldPromptSessionOver(false);
                else
                  setShouldPromptSessionOver(true);
              }} 
            />
            {/*
              <ExerciseTimerWithList 
              exercises={sequences} 
              showButtons={appointment} 
              patientCard={patientCard}
              therapistName={therapistName}
              onRemainingTimeChange={(rt) => setRemainingTime(rt)}
              onWorkoutStart={(status, reorderedExers) => {
                checkAndUpdateRemaining(status, reorderedExers);
              }} 
              onParsedData={(row, idx) => sendToBackend(row, idx, 0)}
              onExerChange={exers => sendExersToBackend(exers)}
              onWorkoutComplete={(status, reorderedExers) => {
                checkAndUpdateRemaining(status, reorderedExers);
                setSessionStatus(status); 
                if (status == "restarted")
                  setShouldPromptSessionOver(false);
                else
                  setShouldPromptSessionOver(true);
              }} 
            />
            */}
            {appointment ?
            <>
               { showExerComment && (
                <button
                  className="floating-drawer-button"
                  style={{ bottom: '5vh' }}
          
                  onClick={async () => {
                    const newVal = await showPrompt('Enter comment:', showExerComment.comments || '');
                    if (newVal !== null) {
                      setTextValue(newVal, showExerComment.idx, 'comments');
                    }
                  }}
                >
                  📝 Comment
                </button>
              )}


              {(shouldPromptSessionOver && !sessionMarked) && (
                <div className={`doctor-card-button ${shouldPromptSessionOver ? 'button-highlight' : ''}`}>
                  <div style={{ marginTop: '1rem', padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffeeba', borderRadius: '8px' }}>
                    <h4 style={{ color: '#856404' }}>⚠️ Please click "Mark Session Over" to finish session properly.</h4>
                     {/*                 
                      <FaLongArrowAltRight
                        className="arrow-pointer-icon"
                        style={{ fontSize: '48px', color: 'black' }}
                      /> */}
                    <button type="button" 
                      className='btn btn-outline-primary' 
                      onClick={openSessionCommentsEscalate}
                      style={{ fontSize: '1.2rem' }}
                    > 
                      View /Escalate ? </button>

                    <button 
                      type="button"
                      className='btn btn-warning btn-lg'
                      //onClick={patientDoneForTheDay}
                      onClick={() => {
                        getTherapists();
                        const isScheduled = appointment?.status?.toLowerCase() === 'scheduled';
                        setScActualStartTime(isScheduled ? toDatetimeLocal(appointment?.start || appointment?.date) : '');
                        setScActualEndTime(toDatetimeLocal());
                        setScExerciseBulkStatus('');
                        setSessionOverModalOpen(true);
                      }}
                      style={{ fontSize: '1.2rem' }}
                    >
                      ✅ Mark Session Over
                    </button>
                 
                </div>
                  </div>
                )}
                  
                  {sessionOverModalOpen && (
                    <div style={styles.modalOverlay}>
                      <div style={{ ...styles.modalContent, maxWidth: '500px' }}>
                        <h3>📝 Session Comments</h3>
                        
                        <select
                            value={leadTherapist || 'selectT'}
                            onChange={(e) => {
                              const value = e.target.value;
                              const selected = therapists.find(t => t.username === value);

                              setLeadTherapist(value);
                              setLeadTherapistDesignation(selected?.designation || "");
                            }}
                          >
                            <option value="selectT">Therapist who led the session</option>
                            {therapists.map(t => (
                              <option key={t.username} value={t.username}>
                                {t.username}
                              </option>
                            ))}
                          </select>
                        
                           <select
                              value={helperTherapist1 || 'selectT'}
                              onChange={(e) =>
                                setHelpTherapist1(e.target.value)
                              }
                            >
                              <option value="selectT">Therapist 1:</option>
                              {therapists.map(t => (
                                <option key={t.username} value={t.username}>
                                  {t.username}
                                </option>
                              ))}
                            </select>
                        
                          <select
                              value={helperTherapist2 || 'selectT'}
                              onChange={(e) =>
                                setHelpTherapist2(e.target.value)
                              }
                            >
                              <option value="selectT">Therapist 2:</option>
                              {therapists.map(t => (
                                <option key={t.username} value={t.username}>
                                  {t.username}
                                </option>
                              ))}
                            </select>
                        {/* Actual time fields */}
                        {appointment?.status?.toLowerCase() === 'scheduled' && (
                          <div style={{ marginBottom: 8 }}>
                            <label>Actual Start Time</label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              value={scActualStartTime}
                              onChange={e => setScActualStartTime(e.target.value)}
                            />
                          </div>
                        )}
                        <div style={{ marginBottom: 8 }}>
                          <label>Actual End Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={scActualEndTime}
                            onChange={e => setScActualEndTime(e.target.value)}
                          />
                        </div>

                        {/* Bulk exercise status */}
                        {rawSequences.length > 0 && (
                          <div style={{ marginBottom: 8 }}>
                            <label>Mark remaining exercises as:</label>
                            <div style={{ display: 'flex', gap: 8, marginTop: 4, flexWrap: 'wrap' }}>
                              {['Skipped', 'Completed'].map(s => (
                                <button
                                  key={s}
                                  type="button"
                                  onClick={() => setScExerciseBulkStatus(v => v === s ? '' : s)}
                                  style={{
                                    padding: '5px 12px', borderRadius: 6, border: '2px solid',
                                    borderColor: scExerciseBulkStatus === s ? (s === 'Skipped' ? '#f59e0b' : '#22c55e') : '#ccc',
                                    background: scExerciseBulkStatus === s ? (s === 'Skipped' ? '#fff8e1' : '#f0fdf4') : '#f5f5f5',
                                    fontWeight: scExerciseBulkStatus === s ? 700 : 400,
                                    cursor: 'pointer'
                                  }}
                                >
                                  {s === 'Skipped' ? '⏭ Skip All Remaining' : '✅ Complete All Remaining'}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}

                        <label>Choose from past comments:</label>
                        <select
                          name="commentSelect"
                          className="form-select"
                          value={therapistComment}
                          onChange={(e) => setTherapistComment(e.target.value)}
                        >
                          <option value="">Select Comment</option>
                          {previousComments.map((comment, idx) => (
                            <option key={idx} value={comment}>{comment}</option>
                          ))}
                        </select>

                        <label style={{ marginTop: '1rem' }}>Or add a new comment:</label>
                        <input
                          type="text"
                          className="form-control"
                          value={therapistComment}
                          placeholder="Add custom comment"
                          onChange={(e) => setTherapistComment(e.target.value)}
                          onBlur={() => {
                            if (
                              therapistComment &&
                              !previousComments.includes(therapistComment)
                            ) {
                              setPreviousComments((prev) => [...prev, therapistComment]);
                            }
                          }}
                        />

                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                          <button
                            className="btn btn-secondary"
                            onClick={() => {
                              setSessionOverModalOpen(false);
                              setTherapistComment("");
                            }}
                          >
                            Cancel
                          </button>

                          <button
                            className="btn btn-success"
                            onClick={() => {
                              handleMarkSessionWithComment("Completed");
                              
                            }}
                            disabled={!therapistComment}
                          >
                            Completed 
                          </button>

                           <button
                            className="btn btn-success"
                            onClick={() => {
                              handleMarkSessionWithComment("Skipped");
                              
                            }}
                            disabled={!therapistComment}
                          >
                            Skipped 
                          </button>

                        </div>
                      </div>
                    </div>
                  )}

       
              {showModal && (
                <EscalationModal
                  appointment={appointment}
                  auth={auth}
                  patientCard={patientCard}
                  onClose={() => setShowModel(false)}
                  refreshSequences={getPatientSequences}
                  variant="modal"
                />
              )}

            </>
            : null}
            {(appointment && <>
            <h4>Share Comments (if any)</h4>
            <button onClick={openModalForAdd}>➕ Add New </button>
          
            <DataTable 
            columns={columns} data={displaySequences} 
            conditionalRowStyles={conditionalRowStyles} 
            pagination highlightOnHover striped responsive pointerOnHover 
            dense paginationPerPage={100} persistTableHead fixedHeader 
            defaultSortField="id" defaultSortAsc />
            </>
            )}
          </div>
          : null}
        </div>
       )
       :
       (
        <>
          <div className='tableheaderActions'>
            {displaySequences && displaySequences[0] && displaySequences[0].status === "notStarted" ?
              <FaPlay onClick={() => setIsModalOpen(true)} style={{color:'green',cursor:'pointer',marginRight:10,marginLeft:-10}} />
            : null}
          </div>
          <DataTable columns={columns} data={displaySequences} 
          conditionalRowStyles={conditionalRowStyles} pagination 
          highlightOnHover striped responsive pointerOnHover dense 
          paginationPerPage={100} persistTableHead fixedHeader 
          defaultSortField="id" defaultSortAsc />
        </>
       )}

      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-box" style={{background: 'white'}}>
            <h3>Add New Sequences</h3>

            <div className="card-wrapper">
              <Sequences
                patientCard={patientCard} 
                filterT="all"
                onDataChange={(data) => handleSeqChange(null,data, "Sequences", false, true)}
                onSeqInProgress ={(showNotif) => console.log('Only new exercises will be shown.')}
              />
            </div>

            {/* ACTIONS */}
            <div   style={{
                  marginTop: 16,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px",
                }}>
              <button onClick={() => setShowAddModal(false)}>Cancel</button>
              <button onClick={(e) => handleSave(e)} >  Submit   </button>
            </div>
          </div>
        </div>
      )}


      {/* ── Schedule Next Appointment modal ── */}
      {showNextApptModal && (
        <div style={styles.modalOverlay}>
          <div style={{ backgroundColor: 'white', padding: '28px', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)', maxWidth: '420px', width: '90vw' }}>
            <h3 style={{ marginTop: 0, marginBottom: 6 }}>✅ Session Done — Schedule Next?</h3>
            <p style={{ margin: '0 0 4px', fontWeight: 600, fontSize: 15 }}>
              {appointment?.title?.split('/')[0] || patientCard}
              {appointment?.title?.split('/')[1] ? ` · ${appointment.title.split('/')[1].trim()}` : ''}
            </p>
            <p style={{ margin: '0 0 16px', fontSize: 13, color: '#666' }}>
              Therapist: <strong>{leadTherapist || appointment?.username || auth.username}</strong>
              {appointment?.branch ? ` · ${appointment.branch}` : ''}
            </p>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: 12 }}>
              <button
                className="btn btn-primary"
                onClick={() => {
                  const t = new Date(appointment?.start || appointment?.date || new Date());
                  t.setDate(t.getDate() + 1);
                  scheduleNextAppointment(t);
                }}
              >
                Tomorrow (same time)
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={() => setNextApptShowPicker(v => !v)}
              >
                Pick date &amp; time
              </button>
            </div>

            {nextApptShowPicker && (
              <div style={{ marginBottom: 12 }}>
                <DatePicker
                  selected={nextApptDate}
                  onChange={date => setNextApptDate(date)}
                  showTimeSelect
                  timeIntervals={30}
                  timeCaption="Time"
                  dateFormat="Pp"
                  minDate={new Date()}
                  inline
                />
                <button
                  className="btn btn-success"
                  style={{ marginTop: 8 }}
                  onClick={() => scheduleNextAppointment(nextApptDate)}
                >
                  Schedule
                </button>
              </div>
            )}

            <hr style={{ margin: '12px 0' }} />
            <button
              style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', textDecoration: 'underline', fontSize: 13 }}
              onClick={closeNextApptModal}
            >
              Skip — go to dashboard
            </button>
          </div>
        </div>
      )}

    </div>
  );
}

export default PatientSequences;
